//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginCard from '@/components/common/login-card'
import RegisterCard from '@/components/common/register-card'
import {availableModules} from '@/enums/availableModules'
import {mapActions, mapGetters, mapState} from 'vuex'
import {adminCodes} from '~/enums/adminSettings'

export default {
  components: {
    RegisterCard,
    LoginCard,
  },
  data() {
    return {
      visibleCard: 'login',
    }
  },
  head() {
    return {
      title: this.$t('login'),
    }
  },
  computed: {
    IsLoggedIn() {
      return this.$auth.loggedIn
    },
    ...mapState('common/cache', ['loadSettings']),
    ...mapGetters('backoffice/settings', ['adminSettingByCode']),
    ContactPhoneNumber() {
      return this.adminSettingByCode(adminCodes.ContactPhoneNumber).value
    },
    ContactEmailAddress() {
      return this.adminSettingByCode(adminCodes.ContactEmailAddress).value
    },
  },
  async mounted() {
    if (this.IsLoggedIn) {
      this.proceedToSelectedModule()
    }
  },
  methods: {
    ...mapActions('common/cache', ['loadingCache']),
    async loggedIn() {
      this.loadingCache()
      await this.proceedToSelectedModule()
    },
    async proceedToSelectedModule() {
      const allAvailableModules = this.$store.getters[
        'common/userProfile/getAvailableModules'
      ].call()
      const userInfo = this.$store.getters[
        'common/userProfile/getUserDetails'
      ].call()
      const currentlySelected = allAvailableModules.filter(
        (module) => module.value === userInfo.startupModuleID
      )

      if (currentlySelected[0]) {
        switch (currentlySelected[0].text) {
          case availableModules.Dashboard:
            await this.$router.push('/backoffice/dashboard')
            break
          case availableModules.Configuration:
            await this.$router.push('/backoffice/configuration')
            break
          case availableModules.Catalog:
            await this.$router.push('/backoffice/catalog')
            break
          case availableModules.CustomerCredits:
            await this.$router.push('/backoffice/financial/customer-credits')
            break
          case availableModules.Invoices:
            await this.$router.push('/backoffice/financial/invoices')
            break
          case availableModules.Payments:
            await this.$router.push('/backoffice/financial/payments')
            break
          case availableModules.CustomOrder:
            await this.$router.push('/backoffice/order-creation/custom-order')
            break
          case availableModules.Estimate:
            await this.$router.push('/backoffice/order-creation/estimate')
            break
          case availableModules.JobOrders:
            await this.$router.push('/backoffice/status-tracking/job-orders')
            break
          case availableModules.Quotes:
            await this.$router.push('/backoffice/status-tracking/quotes')
            break
          case availableModules.SalesOrders:
            await this.$router.push('/backoffice/status-tracking/sales-orders')
            break
        }
      } else {
        await this.$router.push('/backoffice/dashboard')
      }
    },
  },
}
